import { render, staticRenderFns } from "./FileChange.vue?vue&type=template&id=b83344e8&scoped=true"
import script from "./FileChange.vue?vue&type=script&lang=js"
export * from "./FileChange.vue?vue&type=script&lang=js"
import style0 from "./FileChange.vue?vue&type=style&index=0&id=b83344e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83344e8",
  null
  
)

export default component.exports